import {HARBOUR_DETAILS_TOGGLE} from '../constants/harbours';

export const toggleHarbourDetails = () => {
	return {
		type: HARBOUR_DETAILS_TOGGLE,
		payload: {}
	};
};